import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addNotification, removeNotification, clearNotifications } from '../redux/notificationSlice';

export function useNotifications() {
  const state = useSelector((state) => state.notifications);
  const dispatch = useDispatch();

  const notify = useCallback((notification) => {
    if (typeof notification === 'string') {
      notification = { content: notification, localize: true };
    }
    dispatch(addNotification({
      identifier: notification.identifier || 'notification',
      timeout: ('timeout' in notification) ? notification.timeout : 5,
      icon: notification.icon,
      content: notification.content,
      variant: ('variant' in notification) ? notification.variant : 'success',
      localize: notification.localize
    }));
  }, []);

  const remove = useCallback((notificationId) => {
    dispatch(removeNotification(notificationId));
  }, []);

  const clear = useCallback(() => {
    dispatch(clearNotifications());
  }, []);

  return {
    items: state.items,
    notify,
    remove,
    clear
  };
}